// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import App from "./App";
import BreakoutIframe from "./services/BreakoutIframe";
import "./index.css";

// 1️⃣ Create a QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

// 2️⃣ Root container
const root = createRoot(document.getElementById("root"));

// 3️⃣ Optional: register service worker
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/firebase-messaging-sw.js")
//     .then((registration) => {
//       console.log("Service Worker registered with scope:", registration.scope);

//       registration.onupdatefound = () => {
//         const installingWorker = registration.installing;
//         installingWorker.onstatechange = () => {
//           if (installingWorker.state === "installed") {
//             if (navigator.serviceWorker.controller) {
//               console.log("New content is available; please refresh.");
//             } else {
//               console.log("Content is cached for offline use.");
//             }
//           }
//         };
//       };
//     })
//     .catch((error) => {
//       console.error("Service Worker registration failed:", error);
//     });
// }

// 4️⃣ Render the app
root.render(
  <React.StrictMode>
    {/* Provide the QueryClient at the top level */}
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* Optional iframe service */}
        <BreakoutIframe />

        {/* Main app */}
        <App />
      </BrowserRouter>

      {/* Devtools must be inside the provider */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
